import to_array from './to_array';
import closest from 'closest';

function PanelActionButton() {
  const body = document.body;
  body.addEventListener('click', function(e) {
    const button = closest(e.target, '.panel-action', true);
    if(button && button.dataset.target.length) {
      const modal = $(button.dataset.target);
      const value = button.dataset.value;
      const input = button.dataset.input;

      if(input) {
        modal.find(`#${input}, [name="${input}"]`)
          .val(value)
      }

      modal.find('form').first().prop('action', button.dataset.action);

      modal.appendTo('body').modal('show');
    }
  });
}

exports.init = PanelActionButton;
